import { flattenValues } from "@uniformdev/canvas";
import { UniformBlogNewsCardProps } from "src/uniform/contenttypes/blogNewsCard";
import { UniformEventCardProps } from "src/uniform/contenttypes/eventCard";

import {
    GalleryContainer,
    BlogEventCard,
    BlogNewsCard
} from "@/libraries/design/components";

export interface UniformBlogNewsGalleryProps {
    cards: (UniformBlogNewsCardProps | UniformEventCardProps)[];
}

const UniformBlogNewsGallery = ({ cards }: UniformBlogNewsGalleryProps) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const flattenedCards = flattenValues(cards as any) as (
        | UniformBlogNewsCardProps
        | UniformEventCardProps
    )[];
    return (
        <GalleryContainer>
            {flattenedCards.map((card, index) => {
                if (card) {
                    if ("dates" in card) {
                        return (
                            <BlogEventCard
                                key={index}
                                date={card.dates}
                                location={card.location}
                                title={card.title}
                                link={{
                                    href: card.ctaUrl,
                                    text: card.ctaText
                                }}
                                image={{
                                    src: card.imageUrl,
                                    alt: card.imageAlt ?? ""
                                }}
                            />
                        );
                    } else {
                        return (
                            <BlogNewsCard
                                key={index}
                                color={card.color}
                                label={card.label}
                                title={card.title}
                                link={{
                                    href: card.ctaUrl,
                                    text: card.ctaText
                                }}
                                image={{
                                    src: card.imageUrl,
                                    alt: card.imageAlt ?? ""
                                }}
                            />
                        );
                    }
                }
            })}
        </GalleryContainer>
    );
};

export default UniformBlogNewsGallery;
